import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { RequiredMark } from './RequiredMark';

interface FieldLabelProps {
  htmlFor: string;
  isRequired?: boolean | undefined;
  className?: string | undefined;
  children: ReactNode;
}

export function FieldLabel({ htmlFor, isRequired, className, children }: FieldLabelProps) {
  return (
    <Label htmlFor={htmlFor} className={className}>
      <span>
        {children}
        {isRequired ? <RequiredMark /> : null}
      </span>
    </Label>
  );
}
